var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-item"},[_c('div',{staticClass:"headline-holder"},[_vm._t("location-header")],2),_c('div',{staticClass:"content-holder"},[_vm._t("location-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }